import Request from '@/api/request';

export const getMailings = async (params) => {
  return await Request.get('/v1/mailings/subscriptions', params).then((res) => {
    return res;
  });
};

export const postMailing = async (params) => {
  return await Request.formpost('/v1/mailings/subscriptions', params).then((res) => {
      return res;
  });
}